import {useLayer} from "react-laag";
import {Menu} from "@mantine/core";
import {IconCircleCheck} from "@tabler/icons-react";
import {useTranslation} from "react-i18next";

export type MapContextMenuContext = {
  event: google.maps.MapMouseEvent;
  bounds: {
    left: number;
    top: number;
    width: number;
    height: number;
    right: number;
    bottom: number;
  }
}

export type MapContextMenuItem = "NEW_GEOFENCE";

export type MapContextMenuProps = {
  context?: MapContextMenuContext;
  onItemClick: (item: MapContextMenuItem, event: google.maps.MapMouseEvent) => void
  onOutsideClick?: () => void;
}

export const MapContextMenu = (props: MapContextMenuProps) => {
  const {context, onItemClick, onOutsideClick} = props;

  const {t} = useTranslation(["common"]);

  const isOpen = typeof context !== "undefined";

  const {layerProps, renderLayer} = useLayer({
    isOpen: isOpen,
    auto: true,
    placement: "bottom-end",
    triggerOffset: 2,
    onOutsideClick: onOutsideClick,
    layerDimensions: layerSide => ({width: 200, height: 100}),
    trigger: {
      getBounds: () => ({
        left: context?.bounds.left ?? 0,
        top: context?.bounds.top ?? 0,
        width: context?.bounds.width ?? 0,
        height: context?.bounds.height ?? 0,
        right: context?.bounds.right ?? 0,
        bottom: context?.bounds.bottom ?? 0,
      })
    }
  });

  if (!isOpen) {
    return null;
  }

  return (
    <>
      {renderLayer(
        <>
          {isOpen &&
            <div {...layerProps}>
              <Menu shadow="md" width={200} opened={true}>
                <Menu.Dropdown>
                  <Menu.Label>{context.event.latLng.toString()}</Menu.Label>
                  <Menu.Item
                    icon={<IconCircleCheck size={14}/>}
                    onClick={() => onItemClick("NEW_GEOFENCE", context.event)}>
                    {t("common.action.new", "New") + " " + t("common.entity.geofence", "Geofence")}
                  </Menu.Item>
                </Menu.Dropdown>
              </Menu>
            </div>
          }
        </>
      )}
    </>
  )
}
